import { render, staticRenderFns } from "./tariffs.pug?vue&type=template&id=51a1e224&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./tariffs.scss?vue&type=style&index=0&id=51a1e224&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1e224",
  null
  
)

export default component.exports